import { render, staticRenderFns } from "./portabilidade.vue?vue&type=template&id=525988c2&"
import script from "./portabilidade.vue?vue&type=script&lang=js&"
export * from "./portabilidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525988c2')) {
      api.createRecord('525988c2', component.options)
    } else {
      api.reload('525988c2', component.options)
    }
    module.hot.accept("./portabilidade.vue?vue&type=template&id=525988c2&", function () {
      api.rerender('525988c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/portabilidade.vue"
export default component.exports